import { createContext } from 'react';

import { AppConfigErrorScreen } from '../../features/app-config/app-config-error-screen/cdm-app-config-error-screen';
import { useInfieldLanguage } from '../../features/i18n/use-infield-language';
import { useUpsertCurrentUserPreferences } from '../../features/user/hooks/use-mutation/cdm-use-upsert-user-preferences';
import { UserOnboarding } from '../../features/user/user-onboarding/user-onboarding';
import { useCurrentUserContext } from '../current-user-provider/current-user-provider';
import { useCdmSelectedLocationContext } from '../selected-location-provider/cdm-selected-location-context';

export interface CdmUserOnboardingProviderContextInterface {
  useSelectedLocationContext: typeof useCdmSelectedLocationContext;
  useInfieldLanguage: typeof useInfieldLanguage;
  useUpsertCurrentUserPreferences: () => Pick<
    ReturnType<typeof useUpsertCurrentUserPreferences>,
    'mutateAsync'
  >;
  useCurrentUserContext: typeof useCurrentUserContext;
  AppConfigErrorScreen: typeof AppConfigErrorScreen;
  UserOnboarding: typeof UserOnboarding;
}

const defaultContextValue: CdmUserOnboardingProviderContextInterface = {
  useSelectedLocationContext: useCdmSelectedLocationContext,
  useInfieldLanguage,
  useUpsertCurrentUserPreferences,
  useCurrentUserContext,
  AppConfigErrorScreen,
  UserOnboarding,
};

export const CdmUserOnboardingProviderContext =
  createContext<CdmUserOnboardingProviderContextInterface>(defaultContextValue);
